"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
exports.putTestingBlock = (operation, testingKey, context, contextId, nodeUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoint = nodeUrl
        ? nodeUrl + `/node/v5/testblocks`
        : "https://app.brightid.org/node/v5/testblocks";
    try {
        let res;
        switch (operation) {
            case "verification":
                res = yield axios_1.default.put(`${endpoint}/${context}/verification/${contextId}`, null, { params: { testingKey } });
                break;
            case "sponsorship":
                res = yield axios_1.default.put(`${endpoint}/${context}/sponsorship/${contextId}`, null, { params: { testingKey } });
                break;
            case "link":
                res = yield axios_1.default.put(`${endpoint}/${context}/link/${contextId}`, null, {
                    params: { testingKey },
                });
                break;
            default:
                return {};
        }
        console.log(res);
        return {
            status: res.status,
            statusText: "testBlock operation submitted to node successfully",
            data: res.data,
        };
    }
    catch (err) {
        console.log(err.response);
        return {
            status: err.response.status,
            statusText: err.response.statusText,
            data: err.response.data,
        };
    }
});
exports.removeTestingBlock = (operation, testingKey, context, contextId, nodeUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoint = nodeUrl
        ? nodeUrl + `/node/v5/testblocks`
        : "https://app.brightid.org/node/v5/testblocks";
    try {
        let res;
        switch (operation) {
            case "verification":
                res = yield axios_1.default.delete(`${endpoint}/${context}/verification/${contextId}`, { params: { testingKey } });
                break;
            case "sponsorship":
                res = yield axios_1.default.delete(`${endpoint}/${context}/sponsorship/${contextId}`, { params: { testingKey } });
                break;
            case "link":
                res = yield axios_1.default.delete(`${endpoint}/${context}/link/${contextId}`, {
                    params: { testingKey },
                });
                break;
            default:
                return {};
        }
        console.log(res);
        return {
            status: res.status,
            statusText: "remove testBlock operation submitted to node successfully",
            data: res.data,
        };
    }
    catch (err) {
        console.log(err.response);
        return {
            status: err.response.status,
            statusText: err.response.statusText,
            data: err.response.data,
        };
    }
});
